import React, { Component } from 'react';
import ArrangementSearcher from 'components/modals/ArrangementSearcher.js';
import {EFFECTS} from 'constants/arrangement-modes.js';
import { connect } from "react-redux";
import {ARRANGEMENT_TRACK_PATTERN} from 'session/constants.js';
import {deleteRowSelections} from './copy.js';
import {dispatch} from 'session/operations/dispatch.js';
import {splitPianoRollPattern} from 'session/operations/actions.js';
import RollComponent from './RollComponent.js';
import ArrangementBottom from './ArrangementBottom.js';
import {setArrangementBottomResizing} from 'actions/index.js';
import ArrangementBottomResizer from './ArrangementBottomResizer.js';
import SideBrowserContainer from './SideBrowserContainer.js';
import {onKeyDown} from './keyDown.js';
import {copy, paste, isRowSelectionsEmpty, duplicate} from './copy.js';
import SelectionComponent from './SelectionComponent.js';
import {quantizeStep} from './quantizeStep.js';
import {DEFAULT_RESOLUTION} from './constants.js';
import {
    deleteEvent,
    deleteCompoundEvent
} from 'session/operations/actions.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {getBarWidth} from './getBarWidth.js';
import TimeRowComponent from './TimeRowComponent.js';
import TimeBackgroundComponent from './TimeBackgroundComponent.js';
import ClockTickComponent from './ClockTickComponent.js';
import SubArrangementComponent from './SubArrangementComponent.js';
import PatternSwitchEvent from 'session/PatternSwitchEvent.js';
import {
    setArrangementCursorStep,
    setArrangementPatternResizing,
    setIsPlayingMix,
    setArrangementPatternDragging,
    setArrangementSelectedRows,
    setSelectedArrangementEvents,
    setArrangementBottomHeight,
    setArrangementMouseX,
    setArrangementMouseDownX,
} from 'actions/index.js';
import SidePanelContainer from './SidePanelContainer.js';
import ArrangementContainer from './ArrangementContainer.js';
import {
    NO_SUB_SEQUENCE,
    PATTERN_SWITCH,
    SEQUENCE_ROLL,
    RESOLUTION_CHANGE} from 'session/constants.js';
import {INFO_COLUMN_WIDTH} from './constants.js';
import {getStepFromPosition} from './getStepFromPosition.js';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import Track from 'track/Track.js';

import '../../Arrangement.scss';

const MIN_TIME_SINCE_CLICK = 250;
const RIGHT = 'RIGHT';
const LEFT = 'LEFT';

class ArrangementView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            arrangementContainer: undefined
        };

        window.brightness = 120;
        this.idToEvent = {};

        this.onKeyDown = this.onKeyDown.bind(this);
        this.savedArrangementContainer = undefined;

        this.copyRing = {
        };

        this.ref = React.createRef(undefined);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown);
        this.props.sequencerEngine.resolution = DEFAULT_RESOLUTION;

        this.updateTrackSteps();
    }

    updateTrackSteps() {
        // update subsequence
        this.props.sequencerEngine.subSequences.filter(
            s => s.isTrack)
            .forEach(s => s.tracks[0].updateSteps());
    }

    componentWillUnmount() {
        this.props.sequencerEngine.resolution = DEFAULT_RESOLUTION;
        window.removeEventListener('keydown', this.onKeyDown);
    }

    get arrangementContainer() {
        if (this.savedArrangementContainer) {
            return this.savedArrangementContainer;
        }
        this.savedArrangementContainer = document
            .getElementsByClassName('arrangement-container')[0];

        this.setState({
            arrangementContainer: this.savedArrangementContainer
        });

        return this.savedArrangementContainer;
    }


    onKeyDown(event, sequencerEngine) {
        onKeyDown(event, this.props.sequencerEngine);

        if (event.key === 'c' && (event.metaKey || event.ctrlKey)) {
            this.copy();
        }
        if (event.key === 'v' && (event.metaKey || event.ctrlKey)) {
            this.paste();
        }
        if (event.key === 'd' && (event.metaKey || event.ctrlKey)) {
            event.stopPropagation();
            this.duplicate();
        }
        if (event.key === 'e' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            event.stopPropagation();
            this.splitPattern();
        }
    }

    // when the left edge of a pattern is dragged this
    // is called
    onLeftMouseDown(event, subEvent) {
        this.resizing = event;
        this.resizingSubEvent = event;
        this.direction = LEFT;
    }

    // when the right edge of a pattern is dragged this
    // is called
    onRightMouseDown(event, subEvent) {
        this.resizing = event;
        this.resizingSubEvent = event;
        this.direction = RIGHT;
    }

    onMouseLeave() {
        this.props.setArrangementMouseX(undefined);
        this.props.setArrangementCursorStep(undefined);
        this.resizing = undefined;
    }

    get xScale() {
        return this.getState().xScale;
    }

    onMouseDown(event) {
        let mouseX = event === undefined || this.resizing ?
            undefined :
            event.pageX + this.arrangementContainer.scrollLeft;
        this.props.setMouseDownX(event.pageX);
        let step = getStepFromPosition(mouseX, this.props.resolution, undefined, this.props.xScale);
        let quantization = 16 / this.props.resolution * 4;
        let quantizedStep = quantizeStep(step, quantization, false);

        if (quantizedStep !== undefined) {
            this.props.setArrangementCursorStep(quantizedStep);
            this.props.setArrangementMouseX(mouseX);
        }
    }

    // when dragging has stopped or otherwise finished clicking
    // resets everything
    onMouseUp(event) {
        if (this.selecting) {
            this.updateSelectedPatterns();
        }

        let mouseX = event === undefined || this.resizing ?
            undefined :
            event.pageX + this.arrangementContainer.scrollLeft;

        // quantize then convert back to mouseX
        let step = getStepFromPosition(mouseX, this.props.resolution, undefined, this.props.xScale);
        let quantization = 16 / this.props.resolution * 4;
        let quantizedStep = quantizeStep(step, quantization, false);
        mouseX = INFO_COLUMN_WIDTH +
            getBarWidth(quantizedStep, this.props.resolution, this.xScale);

        if (mouseX !== undefined && quantizedStep === this.cursorStep) {
            if (event.pageY > 38 && event.pageY < 65) {
                // user clicked the time bar (so we want to skip that part of the track)
                if (!this.props.sequencerEngine.playing) {
                    /*
                    this.props.playMix();
                    this.props.sequencerEngine.play();
                    */
                }
                let trackStep = this.getQuantizedStepFromPosition(mouseX);
                this.props.sequencerEngine.seekToTrackStep(trackStep);
            }
        }

        this.resizing = undefined;
        this.resizingSubEvent = undefined;
        this.selecting = false;

        this.props.setArrangementPatternDragging(undefined);
    }

    getQuantizedStepFromPosition(x) {
        let step = getStepFromPosition(x, this.props.resolution, this.props.xScale);
        let resolution = 32 / this.props.resolution.resolution;
        let remainder = step % resolution;
        step -= remainder;
        return step;
    }

    onMouseMove(e) {
        if (this.resizing) {
            let x = e.pageX + this.arrangementContainer.scrollLeft;
            let step = getStepFromPosition(e.pageX + this.arrangementContainer.scrollLeft, this.props.resolution);
            let resolution = 32 / this.props.resolution.resolution;
            let remainder = step % resolution;
            step -= remainder;
            let difference = this.resizingSubEvent ?
                step - (this.resizingSubEvent.step + this.resizingSubEvent.duration) :
                step - (this.resizing.step + this.resizing.duration);

            if (this.resizing.getType() === PATTERN_SWITCH) {
                if (this.direction === RIGHT) {
                    this.mixSession.resizeEvent(
                        this.resizing, Math.floor(difference));
                } else {
                    this.resizing.step = Math.floor(step);
                    this.mixSession.updateAllTypeRedux();
                }
            } else if (this.resizing.getType() === SEQUENCE_ROLL) {
                if (this.direction === RIGHT) {
                    this.mixSession.resizeSequenceRoll(
                        this.resizing, this.resizingSubEvent, RIGHT, Math.floor(difference));
                } else {
                    this.mixSession.resizeSequenceRoll(
                        this.resizing, this.resizingSubEvent, LEFT, Math.floor(step));
                }
            }
        }
    }

    updateAllTypeRedux() {
        this.mixSession.updateAllTypeRedux();
    }

    getState() {
        return this.props.sequencerEngine.store.getState().arrangement;
    }

    getSelectionStart() {
        return this.getState().selection === undefined ?
            undefined :
            this.getState().selection.start;
    }

    getSelectionEnd() {
        return this.getState().selection === undefined ?
            undefined :
            this.getState().selection.end;
    }

    get cursorStep() {
        return this.getState().cursorStep;
    }

    updateSelectedPatterns() {
        let fromStep = this.getSelectionStart();
        let toStep = this.getSelectionEnd();

        let events = [];
        for (let i in this.props.patternSwitchEvents) {
            let event = this.props.patternSwitchEvents[i];
            if (event.step >= fromStep &&
                event.step + event.duration <= toStep) {
                events.push(event);
            }
        }

        /*
        this.setState({
            selectedEvents: events
        });
        */
    }

    isSelectedEvent(event, subEvent) {
        /*
        if (subEvent) {
            return this.state.selectedCompoundEvents[event.id] &&
                this.state.selectedCompoundEvents[event.id].indexOf(subEvent) > -1;
        }
        return false;
        */
        return false;
    }

    copy() {
        this.copyRing = copy(this.getState());
    }

    duplicate() {
        duplicate(this.props.sequencerEngine);
    }

    paste() {
        paste(this.props.sequencerEngine, this.copyRing);
    }

    splitPattern() {
        let step = this.cursorStep;
        for (let i in this.selectedRows) {
            let id = this.selectedRows[i];
            let subSequence = this.props.sequencerEngine.getSubSequence(id);
            if (!subSequence.isTrack) {
                continue;
            }
            let track = subSequence.tracks[0];
            let pattern = track.patterns.find(
                p => p.overlapsStep(step));
            if (pattern !== undefined) {
                dispatch(undefined, splitPianoRollPattern(pattern.track, pattern, step));
                this.onMouseLeave();
                return;
            }
        } 
    }

    getMix(subSequenceId) {
        if (subSequenceId === NO_SUB_SEQUENCE.id) {
            return this.props.sequencerEngine.mix;
        }
        return this.props.sequencerEngine
            .getSubSequence(subSequenceId)
            .mix;
    }

    getSelectedEvents() {
        return this.getState().selectedEvents;
    }

    getRowSelections() {
        return this.getState().rowSelections;
    }

    get selectedRows() {
        return this.getState().selectedRows;
    }

    get mixSession() {
        return this.props.sequencerEngine.mix;
    }

    get mix() {
        return this.props.sequencerEngine.mixSession.mix;
    }

    get bottomBarWidth() {
        return 225;
    }

    onMouseMoveResize(e) {
    }

    onGlobalMouseUp() {
        this.props.setArrangementBottomResizing(false);
        this.props.setArrangementPatternResizing(undefined);
    }

    render() {
        let style = {
        };
        if (this.props.showBottom) {
            style.height = window.innerHeight - this.props.bottomHeight - 17;
        }
        return (
            <div
              onMouseUp={(e) => this.onGlobalMouseUp()} 
              onMouseMove={(e) => this.onMouseMoveResize(e)}
              className="arrangement-view">
              <ArrangementSearcher sequencerEngine={this.props.sequencerEngine}/>
              <div className="arrangement-column">
                <div
                  ref={this.ref}
                  style={style}
                  className="full-arrangement-container">
                <SidePanelContainer
                  scrollContainer={this.ref}
                  updateAllTypeRedux={() => this.updateAllTypeRedux()}
                  subSequence={NO_SUB_SEQUENCE}
                  sequencerEngine={this.props.sequencerEngine}
                  />
                <ArrangementContainer
                  yScrollContainer={this.ref}
                  onMouseDown={(e) => this.onMouseDown(e)}
                  onMouseLeave={() => this.onMouseLeave()}
                  onMouseMove={(e) => this.onMouseMove(e)}
                  mixSession={this.mixSession}
                  arrangementContainer={this.state.arrangementContainer}
                  resolution={this.props.resolution}
                  onDragStart={(e, event) => this.onDragPatternEvent(e, event)}
                  onSelect={(event, subEvent) => []}
                  onMouseUp={(event, subEvent) => this.onMouseUp(event, subEvent)}
                  onRightMouseDown={(event, subEvent) => this.onRightMouseDown(event, subEvent)}
                  onLeftMouseDown={(event, subEvent) => this.onLeftMouseDown(event, subEvent)}
                  sequencerEngine={this.props.sequencerEngine}
                  />
                </div>
                </div>
               <ArrangementBottom sequencerEngine={this.props.sequencerEngine}/>
            </div>
        );
    }

    //
    
    /*
               */
                // <SideBrowserContainer
                  //sequencerEngine={this.props.sequencerEngine}
                  ///>
}

const mapDispatchToProps = dispatch => {
    return {
        playMix: () => dispatch(setIsPlayingMix(true)),
        setArrangementMouseX: (mouseX) => dispatch(setArrangementMouseX(mouseX)),
        setMouseDownX: (mouseX) => dispatch(setArrangementMouseDownX(mouseX)),
        setSelectedRows: p => dispatch(setArrangementSelectedRows(p)),
        clearSelectedArrangementEvents: () => dispatch(setSelectedArrangementEvents(undefined)),
        setArrangementBottomResizing: (resizing) =>
            dispatch(setArrangementBottomResizing(resizing)),
        setArrangementBottomHeight: (height) =>
            dispatch(setArrangementBottomHeight(height)),
        setArrangementCursorStep: (x) => dispatch(
            setArrangementCursorStep(x)),
        setArrangementPatternDragging: (x) => dispatch(
            setArrangementPatternDragging(x)),
        setArrangementPatternResizing: (x) => dispatch(
            setArrangementPatternResizing(x)),
    };
};
 
const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.engineId;
    let sub = props.sequencerEngine.currentSubSequence;
    return {
        resolution: DEFAULT_RESOLUTION,
        xScale: state.arrangement.xScale,
        subSequences: state.sequencer.subSequences[id] || [],
        bottomHeight: state.arrangement.bottomHeight,
        showBottom: (state.arrangement.patternSelected && state.arrangement.showTracks[sub.id])
            || state.arrangement.bottomMode === EFFECTS
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(ArrangementView);
